import {config, http} from './__http';

export default {

    getCountryOptions(countries, params) {
        http.get(config.baseUrl()+'/country').then(response => {
            countries(response.data)
        }).catch(e => {
            console.error(e);
        });
    },
    getAvailableCountryOptions(availableCountries, params) {
        http.get(config.baseUrl()+'/country/available').then(response => {
            availableCountries(response.data)
        }).catch(e => {
            console.error(e);
        });
    },
    getCountry(country, id) {
        http.get(config.baseUrl()+'/country/'+id).then(response => {
            country(response.data);
        }).catch(e => {
            console.error(e);
        });
    },
    updateCountry(country, params) {
        http.put(config.baseUrl()+'/country/'+params.Id, params).then(response => {
            country(response.data);
        }).catch(e => {
            coupon(e.response);
        });
    }
}


// WEBPACK FOOTER //
// ./src/api/Country.js